<template>
    <v-app>
        <!-- Barra de navegación superior -->
        <v-app-bar app color="primary" dark>
            <v-toolbar-title>Megafest</v-toolbar-title>

            <!-- Botón Agregar al lado del título -->
            <v-btn color="blue" @click="dialog = true" class="ml-4">
                <v-icon left>mdi-plus</v-icon>
                Agregar
            </v-btn>
            <v-btn color="blue" @click="dialog = true" class="ml-4">
                <v-icon left>mdi-plus</v-icon>
                Administrar
            </v-btn>
            <v-spacer></v-spacer>

            <!-- Nombre del usuario -->
            <v-toolbar-items v-if="usuarioLogueado">
                <v-btn text>
                    <v-icon left>mdi-account</v-icon>
                    {{ usuarioLogueado.nombre }}
                </v-btn>
            </v-toolbar-items>

            <!-- Botón de logout -->
            <v-btn @click="confirmarLogout" icon title="Cerrar sesión">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>

        <v-main>
            <v-sheet class="pa-4">
                <v-btn color="blue" @click="dialog = true" class="mb-4">
                    <v-icon left>mdi-plus</v-icon>
                    AÑADIR MESA Y SILLAS
                </v-btn>

                <!-- Indicador de carga -->
                <v-overlay :model-value="loading" class="align-center justify-center" persistent>
                    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                    <div class="mt-4 text-h6">Cargando...</div>
                </v-overlay>

                <!-- Secciones de mesas -->
                <div v-for="(seccion, nombreSeccion) in mesasAgrupadas" :key="nombreSeccion">
                    <v-divider class="my-4"></v-divider>

                    <v-row align="center" class="mb-2">
                        <v-col cols="auto">
                            <v-icon large :color="getSeccionColor(nombreSeccion)">
                                {{ getSeccionIcon(nombreSeccion) }}
                            </v-icon>
                        </v-col>
                        <v-col>
                            <h2 class="text-h4">{{ nombreSeccion }}</h2>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6" md="4" lg="3" v-for="(mesa, mesaNum) in seccion" :key="mesaNum">

                            <v-card class="ma-2" :data-seccion="nombreSeccion">
                                <v-card-title class="d-flex justify-space-between">
                                    <span>Mesa {{ mesaNum }}</span>
                                    <v-chip small :color="mesaDisponible(mesa) ? 'success' : 'error'">
                                        {{ mesaDisponible(mesa) ? 'Disponible' : 'Ocupada' }}
                                    </v-chip>
                                </v-card-title>

                                <v-card-text>
                                    <!-- Sillas como botones -->
                                    <div class="d-flex flex-wrap">
                                        <v-btn v-for="silla in mesa" :key="silla.silla" icon large class="ma-1"
                                            :color="silla.status ? 'green' : 'red'"
                                            @click="mostrarDetalleSilla(silla, mesaNum, nombreSeccion)">
                                            <v-icon>mdi-seat</v-icon>
                                            <v-tooltip activator="parent" location="top">
                                                Silla {{ silla.silla }} - {{ silla.status ? 'Disponible' : 'Ocupada' }}
                                            </v-tooltip>
                                        </v-btn>
                                    </div>

                                    <!-- Botón para reservar toda la mesa -->
                                    <v-btn v-if="todasLasSillasDisponibles(mesa)" color="primary" block class="mt-2"
                                        @click="mostrarReservarMesa(mesaNum, nombreSeccion)">
                                        <v-icon left>mdi-table</v-icon>
                                        Reservar toda la mesa
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-dialog v-model="dialogSilla" max-width="400">
                    <v-card v-if="sillaSeleccionada">
                        <v-card-title>
                            <span v-if="!sillaSeleccionada.esTodaLaMesa">
                                Silla {{ sillaSeleccionada.sillaData.silla }} - Mesa {{ sillaSeleccionada.mesaNum }}
                            </span>
                            <span v-else>
                                Mesa completa {{ sillaSeleccionada.mesaNum }}
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title>Estado:</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip
                                            :color="sillaSeleccionada.esTodaLaMesa ? 'success' : (sillaSeleccionada.sillaData.status ? 'success' : 'error')">
                                            {{ sillaSeleccionada.esTodaLaMesa ? 'Disponible' :
                                                (sillaSeleccionada.sillaData.status ? 'Disponible' : 'Ocupada') }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item>

                                <template v-if="sillaSeleccionada.sillaData.status || sillaSeleccionada.esTodaLaMesa">
                                    <v-list-item>
                                        <v-text-field v-model="nombreCliente" label="Nombre Completo"
                                            required></v-text-field>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-text-field v-model="carnetCliente" label="Número de Carnet"
                                            required></v-text-field>
                                    </v-list-item>
                                </template>

                                <template v-if="!sillaSeleccionada.sillaData.status && !sillaSeleccionada.esTodaLaMesa">
                                    <!-- <v-list-item>
                                        <v-list-item-title>Cliente:</v-list-item-title>
                                        <v-list-item-subtitle>{{ sillaSeleccionada.sillaData.nombre || 'Sin información'
                                        }}</v-list-item-subtitle>
                                    </v-list-item> -->
                                    <v-list-item>
                                        <v-list-item-title>Cliente:</v-list-item-title>
                                        <v-list-item-subtitle>{{ sillaSeleccionada.sillaData.carnet || 'Sin información'
                                        }}</v-list-item-subtitle>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="dialogSilla = false">Cancelar</v-btn>

                            <v-btn v-if="sillaSeleccionada.sillaData.status || sillaSeleccionada.esTodaLaMesa"
                                color="blue" text @click="reservarSilla" :disabled="!nombreCliente || !carnetCliente">
                                {{ sillaSeleccionada.esTodaLaMesa ? 'Reservar mesa' : 'Reservar' }}
                            </v-btn>

                            <v-btn v-else-if="!sillaSeleccionada.esTodaLaMesa" color="red" text @click="anularReserva">
                                Anular reserva
                            </v-btn>

                            <v-btn v-else color="red" text @click="cancelarReservaMesa">
                                Cancelar reserva mesa
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialog" max-width="600">
                    <v-card>
                        <v-card-title class="text-h5">Registrar Nueva Mesa y Sillas</v-card-title>
                        <v-card-text>
                            <v-form ref="form">
                                <v-autocomplete v-model="nuevaMesa.mesa"
                                    :items="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']" label="Número de Mesa"
                                    required :rules="[v => !!v || 'El número de mesa es requerido']"></v-autocomplete>

                                <v-select v-model="nuevaMesa.seccion" :items="['DORADO', 'DIAMANTE']" label="Sección"
                                    required :rules="[v => !!v || 'La sección es requerida']"></v-select>

                                <v-autocomplete v-model="nuevaMesa.silla" label="Número de Silla" required :items="items_sillas"
                                    :rules="[v => !!v || 'El número de silla es requerido']"></v-autocomplete>

                                <v-switch v-model="nuevaMesa.status" label="Disponible" color="success" :true-value="1"
                                    :false-value="0"></v-switch>

                                <!-- <v-textarea
                v-model="nuevaMesa.descripcion"
                label="Descripción (opcional)"
                rows="2"
                clearable
              ></v-textarea> -->
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="dialog = false">Cancelar</v-btn>
                            <v-btn color="blue" text @click="crearMesaSilla">Crear</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-sheet>
        </v-main>
    </v-app>
</template>

<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import Mesas from '../services/MesasService';
import Reservas from '../services/ReservasService'
export default defineComponent({
    name: 'MesasView',

    setup() {
        const router = useRouter();
        return { router };
    },

    data() {
        return {
            loading: false,
            dialog: false,
            dialogSilla: false,
            mesas: [],
            sillaSeleccionada: null,
            items_sillas : ["1","2","3","4","5","6","7","8","9","10"],
            nombreCliente: '',
            carnetCliente: '',
            nombre_carnet: '',
            nuevaMesa: {
                mesa: '',
                silla: '',
                seccion: '',
                status: 1,
                descripcion: ''
            },
            existente: null,
        };
    },

    computed: {
        mesasAgrupadas() {
            // Primero agrupamos por sección, luego por mesa
            const agrupadas = {};

            this.mesas.forEach(item => {
                if (!agrupadas[item.seccion]) {
                    agrupadas[item.seccion] = {};
                }

                if (!agrupadas[item.seccion][item.mesa]) {
                    agrupadas[item.seccion][item.mesa] = [];
                }

                agrupadas[item.seccion][item.mesa].push({
                    silla: item.silla,
                    status: item.status,
                    descripcion: item.descripcion,
                    nombre: item.nombre,
                    carnet: item.carnet
                });
                console.log(`xxxxxxxxxxxSilla añadida a sección ${item.seccion}, mesa ${item.mesa}:`, {
                    silla: item.silla,
                    status: item.status,
                    descripcion: item.descripcion,
                    nombre: item.nombre,
                    carnet: item.carnet
                });

                // Si deseas ver toda la estructura de la mesa actual después del push:
                console.log(`Contenido actual de mesa ${item.mesa} en sección ${item.seccion}:`, agrupadas[item.seccion][item.mesa]);
            });

            return agrupadas;
        }
    },

    async created() {
        await this.getMesas();
    },

    methods: {
        mostrarReservarMesa(mesaNum, seccion) {

            const mesa = this.mesasAgrupadas[seccion][mesaNum];
            this.sillaSeleccionada = {
                sillaData: {
                    silla: 'TODAS',
                    status: this.todasLasSillasDisponibles(mesa)
                },
                mesaNum,
                seccion,
                esTodaLaMesa: true
            };
            this.dialogSilla = true;
        },

        todasLasSillasDisponibles(mesaSillas) {
            return mesaSillas.every(silla => silla.status);
        },
        // async anularReserva() {
        //         try {
        //             const data = {
        //                 mesa: this.sillaSeleccionada.mesaNum,
        //                 silla: this.sillaSeleccionada.sillaData.silla,
        //                 seccion: this.sillaSeleccionada.seccion
        //             };

        //             const reserva_obj = new Reservas();
        //             const response = await reserva_obj.cancelarReserva(data);

        //             if (response && response.status) {
        //                 await this.getMesas();
        //                 this.dialogSilla = false;
        //                 alert(response.message || 'Reserva anulada exitosamente');
        //             } else {
        //                 alert(response.message || 'Error al anular la reserva');
        //             }
        //         } catch (error) {
        //             console.error('Error al anular reserva:', error);
        //             alert('Error al anular reserva: ' + (error.response?.data?.message || error.message));
        //         }
        //     },
        async anularReserva() {
            try {
                const data = {
                    mesa: this.sillaSeleccionada.mesaNum,
                    silla: this.sillaSeleccionada.sillaData.silla,
                    seccion: this.sillaSeleccionada.seccion
                };

                const reserva_obj = new Reservas();
                const response = await reserva_obj.cancelarReserva(data);

                if (response && response.status) {
                    await this.getMesas();
                    this.dialogSilla = false;
                    alert(response.message || 'Reserva cancelada (se creó registro histórico)');
                } else {
                    alert(response.message || 'Error al cancelar la reserva');
                }
            } catch (error) {
                console.error('Error al anular reserva:', error);
                alert('Error al anular reserva: ' + (error.response?.data?.message || error.message));
            }
        },

        // async cancelarReservaMesa() {
        //     try {
        //         const data = {
        //             mesa: this.sillaSeleccionada.mesaNum,
        //             seccion: this.sillaSeleccionada.seccion
        //         };

        //         const reserva_obj = new Reservas();
        //         const response = await reserva_obj.cancelarReservaMesa(data);

        //         if (response && response.status) {
        //             await this.getMesas();
        //             this.dialogSilla = false;
        //             alert(response.message || 'Reserva de mesa cancelada exitosamente');
        //         } else {
        //             alert(response.message || 'Error al cancelar la reserva de mesa');
        //         }
        //     } catch (error) {
        //         console.error('Error al cancelar reserva de mesa:', error);
        //         alert('Error al cancelar reserva de mesa: ' + (error.response?.data?.message || error.message));
        //     }
        // },
        async cancelarReservaMesa() {
            try {
                const data = {
                    mesa: this.sillaSeleccionada.mesaNum,
                    seccion: this.sillaSeleccionada.seccion
                };

                const reserva_obj = new Reservas();
                const response = await reserva_obj.cancelarReservaMesa(data);

                if (response && response.status) {
                    await this.getMesas();
                    this.dialogSilla = false;
                    alert(response.message || 'Reservas de mesa canceladas (se crearon registros históricos)');
                } else {
                    alert(response.message || 'Error al cancelar las reservas de mesa');
                }
            } catch (error) {
                console.error('Error al cancelar reserva de mesa:', error);
                alert('Error al cancelar reserva de mesa: ' + (error.response?.data?.message || error.message));
            }
        },
        getSeccionIcon(seccion) {
            const iconos = {
                'DORADO': 'mdi-crown',
                'DIAMANTE': 'mdi-diamond-stone'
            };
            return iconos[seccion] || 'mdi-table';
        },

        getSeccionColor(seccion) {
            const colores = {
                'DORADO': 'amber',
                'DIAMANTE': 'light-blue'
            };
            return colores[seccion] || 'grey';
        },

        mesaDisponible(mesaSillas) {
            return mesaSillas.some(silla => silla.status);
        },

        async getMesas() {
            this.loading = true;
            try {
                //const mesas_obj = new Mesas();
                const reserva_obj = new Reservas();
                //const response = await mesas_obj.getmesas();
                const response = await reserva_obj.getDetalleReservas();
                console.log("RESERVA DETALLE",response)
                this.mesas = response;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        mostrarDetalleSilla(sillaData, mesaNum, seccion) {
            console.log("ME VEO EL DIALOGO de LA SILLA");
            this.sillaSeleccionada = {
                sillaData,
                mesaNum,
                seccion,
                esTodaLaMesa: false
            };
            this.dialogSilla = true;
            this.existe_reserva();
        },
        async existe_reserva() {
            try {
                const reserva_obj = new Reservas();
                const reserva_exist = await reserva_obj.existe_reserva_mesa(this.sillaSeleccionada.mesaNum, this.sillaSeleccionada.sillaData.silla, this.sillaSeleccionada.seccion);
                this.existente = reserva_exist[0].status;
                console.log("Existe MESA RESEFVA", this.existente);
            } catch (error) {
                console.error('Error', error);
            }
        },
        async crearMesaSilla() {
            if (!this.$refs.form.validate()) return;

            try {
                const data = {
                    mesa: this.nuevaMesa.mesa,
                    silla: this.nuevaMesa.silla,
                    seccion: this.nuevaMesa.seccion,
                    status: this.nuevaMesa.status,
                    descripcion: this.nuevaMesa.descripcion
                };

                const mesas_obj = new Mesas();
                await mesas_obj.saveMesas(data);
                await this.getMesas();

                this.$refs.form.reset();
                this.dialog = false;
                this.nuevaMesa = {
                    mesa: '',
                    silla: '',
                    seccion: '',
                    status: 1,
                    descripcion: ''
                };

            } catch (error) {
                console.error('Error al crear la mesa:', error);
            }
        },

        async reservarSilla() {
            try {
                const fechaActual = new Date().toISOString().split('T')[0];
                this.nombre_carnet = this.nombreCliente + '-' + this.carnetCliente;

                if (this.sillaSeleccionada.esTodaLaMesa) {
                    // Reservar todas las sillas de la mesa
                    const mesa = this.mesasAgrupadas[this.sillaSeleccionada.seccion][this.sillaSeleccionada.mesaNum];

                    // Crear reservas para cada silla
                    const reserva_obj = new Reservas();
                    for (const silla of mesa) {
                        const dataReserva = {
                            mesa: this.sillaSeleccionada.mesaNum,
                            silla: silla.silla,
                            seccion: this.sillaSeleccionada.seccion,
                            status: false, // Ocupada
                            nombre: this.nombreCliente,
                            carnet: this.nombre_carnet,
                            fecha_inicio: fechaActual,
                        };
                        await reserva_obj.saveReservas(dataReserva);
                    }
                } else {
                    // Reserva individual (tu código actual)
                    if (this.existente) {
                        const dataReserva = {
                            mesa: this.sillaSeleccionada.mesaNum,
                            silla: this.sillaSeleccionada.sillaData.silla,
                            seccion: this.sillaSeleccionada.seccion,
                            status: false,
                            nombre: this.nombreCliente,
                            carnet: this.nombre_carnet,
                            fecha_inicio: fechaActual,
                        };
                        const reserva_obj = new Reservas();
                        await reserva_obj.saveReservas(dataReserva);
                    }
                    else{
                        alert('MESA YA RESERVADA');
                    }
                }

                // Actualizar lista de mesas
                await this.getMesas();

                // Cerrar diálogo y limpiar formulario
                this.dialogSilla = false;
                this.nombreCliente = '';
                this.carnetCliente = '';

                alert('Reserva creada exitosamente');
            } catch (error) {
                console.error('Error al crear la reserva:', error);
                alert('Error al crear la reserva: ' + error.message);
            }
        }
    }
});
</script>

<style scoped>
.v-card {
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
}

.v-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Colores de borde según sección */
.v-card[data-seccion="DORADO"] {
    border-left-color: #FFC107;
    /* amber */
}

.v-card[data-seccion="DIAMANTE"] {
    border-left-color: #03A9F4;
    /* light-blue */
}

/* Estilo para botones de silla */
.v-btn--icon.v-btn--density-default {
    width: 40px;
    height: 40px;
}
</style>